import React from "react"
import SegmentDropdown, { SegmentDropdownProps } from "./SegmentDropdown"

export const SegmentGroupDropdowns = (props: {
  segmentGroups: SegmentDropdownProps<any>["segments"][]
  filters: Record<string, any>
  setFilters: (filters: Record<string, any>) => void
  data: any[]
  segmentCounts: Record<string, number>
  totalCount: number
}) => {
  return (
    <div className="flex gap-2">
      {props.segmentGroups?.map((segment, index) => {
        return (
          <SegmentDropdown<any>
            selected={props.filters?.[`segment-${index}`]}
            setSelected={(value) => {
              props.setFilters((f) => ({ ...f, [`segment-${index}`]: value }))
            }}
            segments={segment}
            key={index}
            data={props.data}
            segmentCounts={props.segmentCounts}
            index={index}
            totalCount={props.totalCount}
          />
        )
      })}
    </div>
  )
}
